var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app__product" },
    [
      _c("div", {
        staticClass: "app__diamond app__diamond--top app__diamond--white"
      }),
      _vm._v(" "),
      _c("Close"),
      _vm._v(" "),
      _vm.step.products
        ? _c("div", { staticClass: "app__productWrapper" }, [
            _c(
              "div",
              {
                staticClass: "app__productWrapper2",
                attrs: { "data-compare": "" }
              },
              [
                _c("StepLabel", { attrs: { step: _vm.step.step_number } }),
                _vm._v(" "),
                _c("Steps", {
                  attrs: {
                    "max-steps": _vm.maxSteps,
                    "active-step": _vm.step.step_number,
                    steps: _vm.steps
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "app__productTitle",
                  domProps: { innerHTML: _vm._s(_vm.step.title) }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "app__productButtonCompare app__productButtonCompare--right"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn__link",
                        attrs: {
                          href: "#",
                          "data-compare-button": "",
                          "data-compare-button-start":
                            _vm.step.compare.compare_label_button_start,
                          "data-compare-button-redirect":
                            _vm.step.compare.compare_label_button_redirect,
                          "data-compare-redirect":
                            _vm.step.compare.compare_url_redirect.url
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "small",
                            attrs: { "data-compare-label": "" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.step.compare.compare_label_button_start
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("i", { staticClass: "icon-strzalka" })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "app__productInnerCompare" },
                  _vm._l(_vm.step.products, function(product) {
                    return _c("div", { staticClass: "app__compareWrapper" }, [
                      _c("div", { staticClass: "app__compare" }, [
                        _c(
                          "div",
                          {
                            staticClass: "cartProduct",
                            attrs: { "data-compare-product": product.ID }
                          },
                          [
                            _c("div", { staticClass: "cartProduct__wrapper" }, [
                              _c(
                                "a",
                                {
                                  ref: "nofollow",
                                  refInFor: true,
                                  staticClass: "cartProduct__image",
                                  attrs: { href: product.url, target: "_self" }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: product.image,
                                      alt: product.title
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "cartProduct__title",
                                  attrs: {
                                    href: product.url,
                                    target: "_self",
                                    title: product.title
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(product.title) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              product.category
                                ? _c(
                                    "div",
                                    { staticClass: "cartProduct__category" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: product.category.url,
                                            target: "_self"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(product.category.name) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              product
                                ? _c(
                                    "div",
                                    { staticClass: "cartProduct__button" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          ref: "nofollow",
                                          refInFor: true,
                                          staticClass:
                                            "btn btn__link btn__rightIcon",
                                          attrs: {
                                            href: product.url,
                                            target: "_self"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(product.compare) +
                                              " "
                                          ),
                                          _c("i", {
                                            staticClass: "icon-strzalka"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      product.up_sell_is_active
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "app__productUpSell app__productUpSell--prl15"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "app__productUpSellImage app__productUpSellImage--w100"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: product.up_sell.image_path,
                                      alt: product.up_sell.name
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "app__productUpSellDesc app__productUpSellDesc--w100",
                                domProps: {
                                  innerHTML: _vm._s(product.up_sell.description)
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "app__productButton" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn__primary",
                      on: {
                        click: function($event) {
                          return _vm.setStart()
                        }
                      }
                    },
                    [
                      _vm._v(_vm._s(_vm.step.label_text) + " "),
                      _c("i", { staticClass: "icon-strzalka" })
                    ]
                  )
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "app__diamond app__diamond--bottom app__diamond--green2"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }